import {
  deepSetObject, digObject, toggleArray,
} from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'

import useUser from '@hooks/useUser'

import { BrandModel } from '@models/types'

import type { ModalCallbacks } from '../index'

type AssignTemplateDeveloperParams = {
  brand: BrandModel,
  callbacks: {
    closeModal: ModalCallbacks['closeModal'],
    updateBrand: ModalCallbacks['updateBrand'],
    updateFn: () => void,
  },
  selectedUserId: number | null,
}

const assignTemplateDeveloper = (params: AssignTemplateDeveloperParams) => {
  const {
    brand,
    callbacks: {
      closeModal,
      updateBrand,
      updateFn,
    },
    selectedUserId,
  } = params

  const templateDeveloperIds = digObject(brand, 'options.template_developer_user_ids', [])
  const updatedTemplateDeveloperIds = toggleArray(templateDeveloperIds, selectedUserId)
  // @ts-expect-error TS2345
  const updatedOptions = deepSetObject(brand.options, 'template_developer_user_ids', updatedTemplateDeveloperIds)

  const updateBrandPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: { options: updatedOptions },
    toastText: 'Template Developer Assigned',
  }

  // @ts-expect-error TS2345
  updateBrand(updateBrandPayload)
}

const defaultState = { selectedUserId: null }

const useManageBrandTemplateDevelopersModal = (brand: BrandModel) => {
  const [state, setState] = useSetState(defaultState)
  const { selectedUserId } = state

  const {
    callbacks: { manageUserTeamMemberRoles },
    user,
  // @ts-expect-error TS2322
  } = useUser({ id: selectedUserId })

  const allowedTeamMemberRoles = digObject(user, 'data.allowed_team_member_roles', [])
  const isUserTemplateDeveloper = allowedTeamMemberRoles.includes('template_developer')

  return {
    callbacks: {
      assignTemplateDeveloper: (callbacks: AssignTemplateDeveloperParams['callbacks']) => (
        assignTemplateDeveloper({ brand, callbacks, selectedUserId })
      ),
      manageUserTeamMemberRoles,
      setState,
    },
    isUserTemplateDeveloper,
    selectedUserId,
  }
}

export default useManageBrandTemplateDevelopersModal
